<img [alt]="this.imageContentModel?.alt ?? ''"
     [attr.fetchpriority]="this.fetchPriority"
     [attr.loading]="this.loading"
     [class]="this.imageClass"
     [src]="this.getUrl()"
/>
